import React, { useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { TabPanel } from 'shared';

import { CreateAutoAssignPackaging } from './createAutoAssignPackaging';
import { ViewAutoAssignPackaging } from './viewAutoAssignPackaging';

function AutoAssignPackaging({ baseUrl }) {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="ViewConfig_Tab" label="View Config" value="0" />
                <Tab id="CreateConfig_Tab" label="Create Config" value="1" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ViewAutoAssignPackaging />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <CreateAutoAssignPackaging />
            </TabPanel>
        </Paper>
    );
}

export { AutoAssignPackaging };
